import {View} from 'MWC';
import tpl from '../templates/MoreSliderBlock.jsx';
import PropTypes from 'prop-types';
import {canUseDOM} from '../../../../helpers/canUseDOM.js';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            proposalAtStart: true,
            proposalAtEnd: false,
            isMobile: canUseDOM ? window.innerWidth <= 767 : false
        };
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
        if (this.swiperCleanup) this.swiperCleanup();
    }

    syncProposalSwiperState = () => {
        const swiper = this.props.swiperRef.current.swiper;

        if (!swiper) return;

        const update = () => {
            if (!swiper || !swiper.slides.length) return;

            this.setState({
                proposalAtStart: swiper.isBeginning,
                proposalAtEnd: swiper.isEnd
            });

            swiper.allowTouchMove = !(swiper.isBeginning && swiper.isEnd);
        };

        swiper.on('setTranslate', update);
        swiper.on('slideChange', update);
        swiper.on('touchEnd', update);
        swiper.on('resize', update);

        setTimeout(() => {
            swiper.update();
            update();
        }, 0);

        return () => {
            swiper.off('setTranslate', update);
            swiper.off('slideChange', update);
            swiper.off('touchEnd', update);
            swiper.off('resize', update);
        };
    };

    updateWidth = () => {
        this.setState({
            isMobile: window.innerWidth <= 767
        });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateWidth);
    }

    slidePrev = () => {
        if (this.props.swiperRef.current.swiper) {
            this.props.swiperRef.current.swiper.slidePrev();
        }
    };

    toggleTab = tab => {
        if (this.props.onTabChange) {
            this.props.onTabChange(tab);
        }
        if (this.props.swiperRef.current.swiper) {
            this.props.swiperRef.current.swiper.slideTo(0, 0);
            this.syncProposalSwiperState();
        }
    };

    slideNext = () => {
        if (this.props.swiperRef.current.swiper) {
            this.props.swiperRef.current.swiper.slideNext();
        }
    };

    navigate = (...args) => {
        return this.context.app.navigate(...args);
    };

    static contextTypes = {
        app: PropTypes.object
    };
}
